import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScriptTag } from '@vueuse/core'

import { useCustomerRegistrationInputStore } from '../useCustomerRegistrationInput'
import { useGoogleSignInId } from '@/plugins/google-sign-in-id'

export function useGoogleSignIn(onGsiSuccess: () => Promise<unknown>) {
    const googleSignInButtonEl = ref<HTMLDivElement | null>(null)

    const { googleSignInToken } = storeToRefs(
        useCustomerRegistrationInputStore()
    )

    const client_id = useGoogleSignInId() || ''

    useScriptTag(
        'https://accounts.google.com/gsi/client',
        () => {
            if (!googleSignInButtonEl.value) {
                return
            }

            google.accounts.id.initialize({
                client_id,
                callback: (response) => {
                    if (response.credential) {
                        googleSignInToken.value = response.credential

                        onGsiSuccess()
                            .catch(() => {})
                            .finally(() => {
                                googleSignInToken.value = null
                            })
                    }
                },
            })

            google.accounts.id.renderButton(googleSignInButtonEl.value, {
                type: 'standard',
                text: 'continue_with',
                shape: 'pill',
                logo_alignment: 'center',
            })
        },
        {
            async: true,
        }
    )

    return { googleSignInButtonEl }
}
